import React, { useState, useEffect, createRef, useCallback, useRef, useMemo } from 'react';
import Storage from '@/amplify/storage';
import {
    Button, Popover, IconButton, Dialog, DialogContent, DialogTitle, Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Checkbox from '@material-ui/core/Checkbox';

import LoadingIndicator from '@/component/common/LoadingIndicator';
import moment from 'moment';
import Utils from '@/common/utils/utils';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Logger from '@/common/utils/Logger';
import _, { cloneDeep } from 'lodash';
import {
    checkPermissionChatPost,
    getChatPostListByChatThreadId,
    sortByCreatedAtAndSeqAsc,
    sortByDeliverAtAndSeqAsc,
    sortByDisplayMessTimeAndSeqAsc,
    sortByUpdatedAtAndSeqAsc,
    validatePostCreateAt
} from '@/service/chatPostService';
import {
    getDelegateUserDetail,
    getDelegateDetail,
    checkDisableUserListDelegateMsg,
    getInfomationChatPostList,
    isEmailTicketCustomerChatthread,
    isEmailMessUndeliver,
    isEmailTicket,
    deliverEmailMsg,
    deliverMsg
} from '@/component/chatThread/handler/ChatPostHandler';
import Constant from '@/common/constant/Constant';
import ErrorModal from '@/component/common/modal/ErrorModal';
import {
    isShowReadNumber,
    isDisabledShowReadList,
    getFootprintNumber,
    initObserverFootprint,
    onClickPopoverFootprint
} from '@/component/chatThread/handler/FootprintHandler';
import { renderStatusSendMsgError } from '@/component/chatThread/component/ChatPost';
import { TicketHead } from '@/component/chatThread/component/TicketHead';
import {
    isEditedMsg,
    isDeleteMsg,
    isShowBlockMsg,
    isShowDeleteTmpMsg,
    initObserverLastMsg,
    updateChatPostBySubsciptionResponse,
    getContentChatPost,
    handleScrollListMessage,
    openShareLinkTicket,
    isShowDeleteTmpMsgWithAlignRule,
    getContentChatPostEmail,
    isUploadingFileMsg,
    extractAiOperatorParams
} from '@/component/chatThread/handler/MessageHandler';
import {
    initSubscriptionChatPost, initSubscriptionMentionChat
} from '@/component/chatThread/handler/SubsciptionHandler';
import CircularProgress from '@material-ui/core/CircularProgress';
import WarningIcon from '@material-ui/icons/InfoTwoTone';
import { handleClickViewTicketDetail, generateTicketOutlineOnTabChat } from '../ticketList/handler/TicketHandler';
import ChatInput from './chatInput/ChatInput';
import { addMentionUserToList, removeMentionUserFromList, isAIAssistantThread } from './handler/ChatThreadHandler';
import EditChatPost from './chatInput/EditChatPost';
import DeleteMessageDialog from './messageDialog/DeleteMessageDialog';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import AIResponse from '@/component/chatAI/element/AIResponse';
import { ListReactionByChatPost } from './component/ListReactionByChatPost';
import ReactionErrorDialog from './messageDialog/ReactionErrorDialog';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { setPanelSelector, triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import { signOut } from '@/service/authenService';
import { detailEmailTicketAtom, openReplyDetailEmailAtom } from '@/state/atom/emailTicketAtom';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { updateHelpdeskTicketDetailByTicketId } from '../ticketList/handler/TicketListHandler';
import { getTicketById } from '@/service/ticketService';
import { lastedSendMsgId } from '../../state/atom/chatAtom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { CkeditorConfiguration } from '@/common/constant/CkEditorConfiguration';
import FlagMessageCopy from './tooltip/FlagMessageCopy';
import PropTypes from 'prop-types';
import { AttachFile } from './AttachFile';
import { ChatBoxToolTicket } from './ChatBoxToolTicket';
import { ReactionChatPost } from './component/ReactionChatPost';
import TelephoneConstant from '@/common/constant/TelephoneConstant';

// @voice call import
import { voiceStatusAtom } from '@/state/atom/voiceCallAtom';
import { initSubscriptionChatThread } from './handler/ChatThreadSubsciptionHandler';
import {
    clearUploadedFilesByPost,
    getChatAttachmentFiles,
    isChatImageAttachment
} from './handler/ChatAttachmentHandler';
import SdeskMcpConstant from '@/common/constant/SdeskMcpConstant';
import trI18n from '@/common/utils/trI18n';
import I18n from '@/rI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { initChatPostOnDemand, isEmailCustomerThread, autoTranslateNewMessages } from '@/component/multiLanguage/handlers/ChatPostOnDemandHandler';
import { chatPostOnDemandAtom } from '@/state/atom/translationAtom';
import ChatPostTranslationView from '@/component/multiLanguage/elements/ChatPostTranslationView';
import useKeepChatScrollOnViewChange from '@/component/multiLanguage/hooks/useKeepChatScrollOnViewChange';
import CorporationUtils from '@/common/utils/CorporationUtils';
import TranslationConstant from '@/common/constant/TranslationConstant';

Chat.propTypes = {
    props: {
        ticketInfo: PropTypes.shape({
            affiliationProject: PropTypes.string,
            id: PropTypes.string
        }),
        viewerChatThreadCorporationDetail: PropTypes.shape({
            organizationDomain: PropTypes.string
        })
    },
    focusedMsgId: PropTypes.any,
    scrollResetKey: PropTypes.number,
    setFocusedMsgId: PropTypes.any,
    ticketOriginInfor: PropTypes.any,
    ticketInfo: PropTypes.any
};   

function Chat({
    API,
    history,
    ticketIdSelected,
    panelId,
    ...props
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const {
        ticketInfo,
        setTicketInfo,
        selectThread,
        setIsLoading,
        corporationDetail,
        projectInuseDetail,
        setProjectInuseDetail,
        userDetail,
        setUserDetail,
        chatPostAllList,
        isShowAllChatPost,
        setIsShowAllChatPost,
        isProjectManager,
        customerReferenceThread,
        customerThread,
        internalThread,
        aiAssistantThread,
        escalationThread,
        delegateThread,
        chatPostUpdate,
        setChatPostUpdate,
        userListCanMention,
        setUserListCanMention,
        projectIdListForSubscriptionMention,
        // exclusiveStartKey, 
        // setExclusiveStartKey,
        lastedCountList, 
        setLastedCountList,
        threadChatList,
        listChatInputValues,
        setListChatInputValues,
        subsciptionChatPostUpdateResponse,
        setSubsciptionChatPostUpdateResponse,
        ticketOriginInfor,
        focusedMsgId,
        setFocusedMsgId
    } = props;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [chatPostOnDemand, setChatPostOnDemand] = useRecoilState(chatPostOnDemandAtom);
    const [isEnableChat, setIsEnableChat] = useState(false);
    const [chatPostByChatThreadIdList, setChatPostByChatThreadIdList] = useState([]);
    const [chatPostUnsentByChatThreadIdList, setChatPostUnsentByChatThreadIdList] = useState([]);
    const [chatThreadId, setChatThreadId] = useState('');

    const [messageError, setMessageError] = useState('');
    const [isDisplayTicketHeadLine, setIsDisPlayTicketHeadLine] = useState(false);

    const [fileUploading, setFileUploading] = useState({});
    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);

    const corporationId = localStorageUtil.getAffiliationOrganization();
    const selectedProjectId = localStorageUtil.getSelectedProjectId();

    // footprint
    const [msgRefList, setMsgRefList] = useState([]);
    const [userFootprintList, setUserFootprintList] = useState([]);

    const [msgEditSelected, setMsgEditSelected] = useState();
    const [isShowModalEditMsg, setIsShowModalEditMsg] = useState(false);
    const [isCreateNewMsg, setIsCreateNewMsg] = useState(false);
    const [isShowReconnectDialog, setIsShowReconnectDialog] = useState(false);
    const chatThreadAll = {};

    // footprint opover
    const [footPrintPopover, setFootPrintPopover] = useState(null);
    const [footPrintPopoverId, setFootPrintPopoverId] = useState(null);
    const openPopover = Boolean(footPrintPopover);
    const id = openPopover ? 'simple-popover' : undefined;

    // reaction popover
    const [reactionPopover, setReactionPopover] = useState(null);
    const [reactionPopoverId, setReactionPopoverId] = useState(null);
    const openReactionPopover = Boolean(reactionPopover);
    const reactionId = reactionPopover ? 'reaction-popover' : undefined;

    const [reactionErrorMsg, setReactionErrorMsg] = useState('');
    const [isOpenReactionErrorDialog, setIsOpenReactionErrorDialog] = useState(false);

    // dialog history msg
    const [isOpenHistoryDialog, setIsOpenHistoryDialog] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    const [isLoadingHistoryList, setIsLoadingHistoryList] = useState(false);
    const [msgContentList, setMsgContentList] = useState({});
    const [editedMsgList, setEditedMsgList] = useState({});
    const [statusDeleteMsgList, setStatusDeleteMsgList] = useState({});
    const [footprintDetailList, setFootprintDetailList] = useState({});

    const [delegateUserDetail, setDelegateUserDetail] = useState({});

    const [isDisableUserListDelegateMsg, setIsDisableUserListDelegateMsg] = useState(false);

    // const [subsciptionChatPostUpdateResponse, setSubsciptionChatPostUpdateResponse] = useState({});

    const [projectOriginOfTicketSelected, setProjectOriginOfTicketSelected] = useState(null);

    // const chatPostUpdate
    const [userProjectMentionUpdated, setUserProjectMentionUpdated] = useState({});
    const isArchive = ticketInfo.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;

    // @voice call state - device and connection stored in window (initialized in HeaderTop)
    const [voiceStatus, setVoiceStatus] = useRecoilState(voiceStatusAtom);

    const [isDisplayJump, setIsDisplayJump] = useState(false);
    const [openModalDeleteMsg, setOpenModalDeleteMsg] = useState({isOpen: false, msg: null});
    
    const indexChatInputValue = Utils.findIndexInArrayById(selectThread?.id, listChatInputValues);
    let infoChatInputValue = listChatInputValues[indexChatInputValue];
    const { isCheckDelegatePostMsg, isPostCreatedAtCurrentTime, postCreatedAtDateTime } = { ...infoChatInputValue }
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [isDeliver, setIsDeliver] = useState(false);
    const [isSentMessage,setIsSentMessage] = useState(true);
    const [isDisableUnsentCheckBox, setIsDisableUnsentCheckBox] =  useState(false);
    const [triggerEmailTicket, setTriggerEmailTicket] = useRecoilState(detailEmailTicketAtom);
    const [latestCustomerMess, setLatestCustomerMess] = useState(null);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [lastedSendMsgIdState, setLastedSendMsgIdState] = useRecoilState(lastedSendMsgId);
    const [triggerOpenReplyEmail, setTriggerOpenReplyEmail] = useRecoilState(openReplyDetailEmailAtom);
    const [chatPostShowFlagMsgCopyMsgId, setChatPostShowFlagMsgCopyMsgId] = useState({})
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: trI18n('MSG-CM-DELETED-CONTENT'),
        confirmTxt: trI18n('CM-BUTTON-OK')
    });

    const isTelephoneEscalationThread = useMemo(() => {
        const isEscalationThread =
            selectThread?.threadType === Constant.THREAD_TYPE.ESCALATION;

        return (
            isEscalationThread &&
            (
                ticketInfo?.ticketType === Constant.TICKET_TYPE.TELEPHONE ||
                ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.TELEPHONE ||
                (
                    ticketInfo?.ticketType === Constant.TICKET_TYPE.ESCALATION &&
                    props?.ticketParent?.ticketType === Constant.TICKET_TYPE.TELEPHONE
                )
            )
        );
    }, [
        selectThread?.threadType,
        ticketInfo?.ticketType,
        ticketOriginInfor?.ticketType,
        props?.ticketParent?.ticketType
    ]);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [uploadFiles, setUploadFiles] = useState([]);
    const reloadPanel = useSetRecoilState(triggerReloadTicketListByPanelType);
    const [isRendering, setIsRendering] = useState(false);
    const [idMessageRendering, setIdMessageRendering] = useState('');
    const [logUrl, setLogUrl] = useState('');
    const [isChatThreadOnAiAssistant, setIsChatThreadOnAiAssistant] = useState(false);

    const getIsAIAssistantEnabledForCurrentThread = useCallback(() => {
        const threadId = aiAssistantThread?.id;
        const toggleOverrideMap = props?.aiAssistantToggleOverrideByThreadIdRef?.current;

        if (threadId && toggleOverrideMap instanceof Map) {
            const overrideValue = toggleOverrideMap.get(threadId);
            if (typeof overrideValue === 'boolean') {
                return overrideValue;
            }
        }

        return aiAssistantThread?.aiAssistantStatus === TelephoneConstant.AI_ASSISTANT_STATUS.ON;
    }, [aiAssistantThread?.id, aiAssistantThread?.aiAssistantStatus, props?.aiAssistantToggleOverrideByThreadIdRef]);

        const [isAIAssistantSettingOff, setIsAIAssistantSettingOff] = useState(() => {
        return isAIAssistantThread(selectThread) && (
            !Utils.isCorporationOnAIAuto(corporationDetail) ||
            !Utils.isEnableSettingTelephoneAgent(corporationDetail) ||
            !Utils.isProjectDeskOn(projectInuseDetail)
        );
    });

    // Force update isAIAssistantSettingOff when corp/project setting changes realtime
    useEffect(() => {
        const settingOff = isAIAssistantThread(selectThread) && (
            !Utils.isCorporationOnAIAuto(corporationDetail) ||
            !Utils.isEnableSettingTelephoneAgent(corporationDetail) ||
            !Utils.isProjectDeskOn(projectInuseDetail)
        );
        setIsAIAssistantSettingOff(settingOff);
    }, [corporationDetail, selectThread, projectInuseDetail]);

    const isAIAssistantEnabledForCurrentThread = getIsAIAssistantEnabledForCurrentThread();

    const chatPostAllListRef = useRef(chatPostAllList);
    useEffect(() => {
        chatPostAllListRef.current = chatPostAllList;
    }, [chatPostAllList]);

    // Timer for debouncing (batching) on-demand auto-translation of new messages.
    const autoTranslateTimerRef = useRef(null);

    // Single owner of the automatic scroll: initial position (first unread / bottom), focus message, translation restore.
    const { onChatScroll, scrollToBottom, isFocusScrolling } = useKeepChatScrollOnViewChange({
        panelId,
        chatThreadId,
        chatPostOnDemand,
        chatPostList: chatPostByChatThreadIdList,
        focusedMsgId,
        scrollResetKey: props.scrollResetKey,
        currentUserId: userDetail?.id
    });

    const isDisableActionEditTicket = () => {
        if ([Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo.ticketType)) {
            const ticketStatus = Utils.convertJSONDataToObject(ticketInfo.status);
            return (
                ticketStatus.value === Constant.STATUS_NO.DONE &&
                (
                    !Utils.isPublicDesk(projectInuseDetail) ||
                    !Utils.isEnableCreateEmailTicketModeOnSkipProjectType(corporationDetail, projectInuseDetail)
                )
            )
        }

        return false;
    }

    let isDisableLink = isArchive || !Utils.isEmptyString(ticketInfo.deletedAt) || isDisableActionEditTicket();

    const getAiOperatorInfoFromPost = useCallback((post) => {
        if (!post) return null;
        return (
            extractAiOperatorParams(post?.creatorId) ||
            extractAiOperatorParams(post?.userDetailPostMsg?.id)
        );
    }, []);
    
    let args = {
        API: API,
        panelId: panelId,
        userDetail: userDetail,
        setIsLoading: setIsLoading,
        msgContentList: msgContentList,
        setMsgContentList: setMsgContentList,
        statusDeleteMsgList: statusDeleteMsgList,
        setStatusDeleteMsgList: setStatusDeleteMsgList,
        editedMsgList: editedMsgList,
        msgEditSelected: msgEditSelected,
        setEditedMsgList: setEditedMsgList,
        footprintDetailList: footprintDetailList,
        setFootprintDetailList: setFootprintDetailList,
        chatPostAllList: chatPostAllList,
        isShowAllChatPost: isShowAllChatPost,
        selectThread: selectThread,
        setChatPostAllList: props.setChatPostAllList,
        setIsShowReconnectDialog: setIsShowReconnectDialog,
        isShowReconnectDialog: isShowReconnectDialog,
        setChatPostUpdate: setChatPostUpdate,
        ticketDetailSelected: ticketInfo,
        setIsDisableUserListDelegateMsg: setIsDisableUserListDelegateMsg,
        subsciptionChatPostUpdateResponse: subsciptionChatPostUpdateResponse,
        setSubsciptionChatPostUpdateResponse: setSubsciptionChatPostUpdateResponse,
        isEnableChat, 
        setIsEnableChat,
        // chat thread
        chatThreadAll,
        ticketInfo,

        userChatList: props.userChatList,
        setUserChatList: props.setUserChatList,
        userListCanMention,
        setUserListCanMention,
        userProjectMentionUpdated, 
        setUserProjectMentionUpdated,

        setIsShowModalEditMsg,
        // exclusiveStartKey, 
        // setExclusiveStartKey,
        lastedCountList, 
        setLastedCountList,
        isDisplayJump, 
        setIsDisplayJump,

        openModalDeleteMsg,
        setOpenModalDeleteMsg,

        reactionPopover, 
        setReactionPopover,
        reactionPopoverId, 
        setReactionPopoverId,
        openReactionPopover,
        reactionId,
        reactionErrorMsg,
        setReactionErrorMsg,
        isOpenReactionErrorDialog,
        setIsOpenReactionErrorDialog,

        infoChatInputValue,
        chatPostByChatThreadIdList,
        ...props,
        lastedSendMsgIdState,
        setLastedSendMsgIdState,
        projectInuseDetail
    };

    useEffect(() => {
        return () => {
            // cleanup function
            
            setIsEnableChat(false);
            setChatPostByChatThreadIdList([]);
            setChatPostUnsentByChatThreadIdList([]);
            setChatThreadId('');
            setMessageError('');
            setIsDisPlayTicketHeadLine(false);
            setFileUploading({});
            setIsModalUploadFileError(false);
            setMsgRefList([]);
            setUserFootprintList([]);
            setMsgEditSelected();
            setIsShowModalEditMsg(false);
            setIsCreateNewMsg(false);
            setIsShowReconnectDialog(false);
            setFootPrintPopover(null);
            setFootPrintPopoverId(null);
            setReactionPopover(null);
            setReactionPopoverId(null);
            setReactionErrorMsg('');
            setIsOpenReactionErrorDialog(false);
            setIsOpenHistoryDialog(false);
            setHistoryList([]);
            setIsLoadingHistoryList(false);
            setMsgContentList({});
            setEditedMsgList({});
            setStatusDeleteMsgList({});
            setFootprintDetailList({});
            setDelegateUserDetail({});
            setIsDisableUserListDelegateMsg(false);
            setProjectOriginOfTicketSelected(null);
            setUserProjectMentionUpdated({});
            setIsDisplayJump(false);
            setOpenModalDeleteMsg({ isOpen: false, msg: null });
            setIsOpenPopupKnowledgeOff(false);
            setIsOpenAccessDeniedPopup(false);
            setIsOpenNotFoundTicketPopup(false);

        };
    }, []);


    const checkIsTelephoneTicketDuringCall = () => {
        if (selectThread?.threadType === Constant.THREAD_TYPE.AI_ASSISTANT) {
            if (!isAIAssistantEnabledForCurrentThread) {
                return false;
            }

            let telephoneStatus = Utils.convertJSONDataToObject(ticketInfo.telephoneStatus);

            if (telephoneStatus.value === 2) {
                return true
            }
        }

        return false
    }

    // DEBUG: log selectThread & ticketInfo
    useEffect(() => {
        if (!isAIAssistantEnabledForCurrentThread) {
            setIsRendering(false);
            if (!Utils.isEmptyString(idMessageRendering)) {
                setIdMessageRendering('');
            }
            return;
        }

        const isDuringCall = checkIsTelephoneTicketDuringCall();

        if(isDuringCall){
            setIsRendering(true)
        }else if(Utils.isEmptyString(idMessageRendering)){
            setIsRendering(false)
        }
    }, [selectThread, ticketInfo, idMessageRendering, isAIAssistantEnabledForCurrentThread]);

    // @end voice call

    useEffect(() => {
        let idDivContentList = `divChatContentList-${panelId}-${chatThreadId}`;
        const element = document.getElementById(idDivContentList);
        const scrollRenderingMsgToBottom = () => {
            if (!element) return;
            requestAnimationFrame(() => {
                scrollToBottom();
                setIsDisplayJump(false);
            });
        };

        if (element) {
            const isAtBottom =
                element.scrollHeight - element.scrollTop - element.clientHeight <= 100;
            setIsDisplayJump(!isAtBottom);
        }

        if(idMessageRendering && chatPostUpdate.id === idMessageRendering && isAIAssistantThread(selectThread)){
            scrollRenderingMsgToBottom();
            setIdMessageRendering('');
            const isDuringCall = checkIsTelephoneTicketDuringCall();
            if(!isDuringCall){
                setIsRendering(false)
            }
        }
    }, [chatPostUpdate]);


    // listen event userProjectMentionUpdated
    useEffect(() => {
        const controller1 = new AbortController();
        if(!Utils.isEmptyObject(userProjectMentionUpdated)) {
            if (userProjectMentionUpdated.subcriptionType === Constant.SUBSCRIPTION_TYPE.CREATE) {
                addMentionUserToList(args, userProjectMentionUpdated);
            } else if (userProjectMentionUpdated.subcriptionType === Constant.SUBSCRIPTION_TYPE.DELETE) {
                removeMentionUserFromList(args, userProjectMentionUpdated);
            }
        }

        return () => {
            controller1.abort();
        }
    }, [userProjectMentionUpdated])

    /**
     * Init subscription chat post mention
     */
    useEffect(() => {
        initSubscriptionMentionChat(args, projectIdListForSubscriptionMention);
    }, [projectIdListForSubscriptionMention])

    /**
     * Init subscription chat post
     */
    useEffect(() => {
        // init subscription handler
        chatThreadAll.customerReferenceThread = customerReferenceThread;
        chatThreadAll.customerThread = customerThread;
        chatThreadAll.internalThread = internalThread;
        chatThreadAll.aiAssistantThread = aiAssistantThread;
        chatThreadAll.escalationThread = escalationThread;
        chatThreadAll.delegateThread = delegateThread;

        initSubscriptionChatPost(args);
       
    }, [customerReferenceThread, customerThread,
        internalThread, aiAssistantThread, escalationThread,
        delegateThread, chatPostAllList,
        isShowAllChatPost, selectThread, ticketInfo]);

    useEffect(() => {
        const controller2 = new AbortController();
        if (
            !Utils.isEmptyObject(ticketInfo) &&
            ticketInfo.projectOrigin !== projectOriginOfTicketSelected &&
            !Utils.isEmptyObject(args.userDelegateCreateTicketDetail)
        ) {
            // Check disable user list delegate msg
            checkDisableUserListDelegateMsg({
                API,
                ticketDetailSelected: ticketInfo,
                setIsDisableUserListDelegateMsg: setIsDisableUserListDelegateMsg,
                userDelegateCreateTicketDetail: props.userDelegateCreateTicketDetail,
                userGuestList: props.userGuestList
            });
            setProjectOriginOfTicketSelected(ticketInfo.projectOrigin);
        }

        return () => {
            controller2.abort();
        }
    }, [ticketInfo, isCheckDelegatePostMsg]);

    /**
     * Check permission chat post
     */
    useEffect(() => {
        const controller3 = new AbortController();
        if (Utils.isEmptyObject(projectInuseDetail)) {
            setIsEnableChat(false);
            return () => {
                controller3.abort();
            }
        }

        // ticketInfo may briefly point to a previous ticket while threads load (focus-from-message flow).
        // Only evaluate chat permission once ticketInfo matches the ticket of the selected thread,
        // otherwise permission would be computed against the wrong ticket and hide the chat input.
        if (
            !Utils.isEmptyObject(selectThread) &&
            selectThread?.ticketId &&
            ticketInfo?.id &&
            selectThread.ticketId !== ticketInfo.id
        ) {
            return () => {
                controller3.abort();
            }
        }

        checkPermissionChatPost(
            API,
            userDetail,
            ticketInfo,
            selectThread,
            projectInuseDetail,
            isProjectManager,
            corporationDetail,
            props.panelType
        ).then(enableChat => {
            setIsEnableChat(enableChat);
        });

        return () => {
            controller3.abort();
        }
    }, [userDetail, selectThread, ticketInfo, projectInuseDetail, isProjectManager, corporationDetail, props?.panelType, props?.triggerReload]);

    /**
     * Check sent message status & ticket headline
     */
    useEffect(() => {
        if (
            isTelephoneEscalationThread ||
            !Constant.TICKET_TYPES_WITH_UNSENT_TOGGLE.includes({...ticketInfo}?.ticketType) || (
                { ...selectThread }.threadType !== Constant.THREAD_TYPE.CUSTOMER &&
                { ...selectThread }.threadType !== Constant.THREAD_TYPE.ESCALATION
            )
        ) {
            setIsSentMessage(true)
        }

        checkDisplayTicketHeadLine();
    }, [isTelephoneEscalationThread, ticketInfo, selectThread]);
    
    useEffect(() => {
        if (Utils.isEmptyObject(ticketInfo) && ticketIdSelected) {
            getTicketById(props?.API, ticketIdSelected).then(ticketData => {
                setTicketInfo(ticketData)
            })
        }
        return () => {
            
        };
    }, [ticketIdSelected]);

    /**
     * Check delegate thread
     */
    useEffect(() => {
        setChatThreadId(selectThread?.id);
        if (selectThread) initSubscriptionChatThread(selectThread?.id, args?.panelId, setVoiceStatus, voiceStatus);
        
    }, [selectThread]);

    useEffect(() => {
        let isCancelled = false;

        const ensureAIAssistantPostsLoadedWhenStacked = async () => {
            if (
                !selectThread?.id ||
                !isAIAssistantThread(selectThread) ||
                !isShowAllChatPost
            ) {
                return;
            }

            const hasAIAssistantPosts = (chatPostAllListRef.current || []).some(
                post => post?.chatThreadId === selectThread.id
            );
            if (hasAIAssistantPosts) {
                return;
            }

            try {
                setIsLoading(true);
                const posts = await getChatPostListByChatThreadId(
                    null,
                    [selectThread.id],
                    0,
                    projectInuseDetail.id
                );

                if (isCancelled) return;

                if (!Utils.isEmptyObject(posts)) {
                    const existingPostIdSet = new Set(
                        (chatPostAllListRef.current || []).map(post => post?.id).filter(Boolean)
                    );
                    const missingPosts = (posts.chatPostAllList || []).filter(
                        post => post?.id && !existingPostIdSet.has(post.id)
                    );

                    if (missingPosts.length > 0) {
                        props.setChatPostAllList({
                            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.CONCAT,
                            posts: missingPosts
                        });
                    }

                    const userChatListClone = cloneDeep(posts.userChatList || []);
                    const currentUserChatList = props.userChatList || [];
                    const mergedUserChatList = cloneDeep(currentUserChatList);
                    userChatListClone.forEach(user => {
                        if (Utils.findIndexInArrayById(user.id, mergedUserChatList) === -1) {
                            mergedUserChatList.push(user);
                        }
                    });
                    props.setUserChatList(mergedUserChatList);
                }
            } catch (error) {
                Logger.error('ensureAIAssistantPostsLoadedWhenStacked error: ', error);
            } finally {
                if (!isCancelled) {
                    setIsLoading(false);
                }
            }
        };

        ensureAIAssistantPostsLoadedWhenStacked();

        return () => {
            isCancelled = true;
        };
    }, [
        projectInuseDetail.id,
        selectThread?.id,
        selectThread?.threadType,
        isShowAllChatPost
    ]);


    useEffect(() => {
        Logger.info('useEffect onSubscriptionEventUpdateChatPost: ', subsciptionChatPostUpdateResponse);

        if (Utils.isEmptyObject(subsciptionChatPostUpdateResponse)) {
            return;
        }

        updateChatPostBySubsciptionResponse(
            {
                chatPostAllList,
                API,
                msgContentList,
                setMsgContentList,
                editedMsgList,
                setEditedMsgList,
                statusDeleteMsgList,
                setStatusDeleteMsgList,
                setChatPostUpdate,
                footprintDetailList,
                setFootprintDetailList,
                userChatList: props.userChatList,
                setUserChatList:props.setUserChatList,
                panelType: props.panelType,
                ticketInfo
            },
            subsciptionChatPostUpdateResponse
        );

    }, [subsciptionChatPostUpdateResponse]);

    /**
     * Get chat post list by chatThreadId
     */
    useEffect(() => {
        let chatPostList = Utils.isEmptyString(chatThreadId) ? [] : chatPostAllList;
        const allThread = {
            customerReferenceThread,
            customerThread,
            internalThread,
            aiAssistantThread,
            escalationThread
        }
        if (!isShowAllChatPost) {
            chatPostList = _.filter(chatPostAllList, post => {
                return post.chatThreadId === chatThreadId
            });
        }
        chatPostList = getInfomationChatPostList(allThread, chatPostList);
        const listChatPostUnsent = chatPostList?.filter(chatPost => chatPost.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER);
        setChatPostUnsentByChatThreadIdList(listChatPostUnsent);
        chatPostList = chatPostList?.filter(chatPost => chatPost.deliverInfo?.status != Constant.DELIVER_STATUS.UNDELIVER);
        setChatPostByChatThreadIdList(chatPostList);

        // Find latest customer mess
        if (isEmailTicket(ticketInfo, selectThread)) {
            let sortedChatPostList = sortChatpostListInEmailTicket(chatPostList);
            findLatestCustomerMess(sortedChatPostList);
        }
        
    }, [chatThreadId, isShowAllChatPost, chatPostAllList, props.isDataChanged]);

    /**
     * Init / refresh on-demand translation state (CHT-005) from the SAME list the
     * UI renders (chatPostByChatThreadIdList). Driving it from the rendered list
     * keeps the atom in sync with newly arrived posts (e.g. realtime subscription)
     * that update the rendered list without re-running the loader effect above.
     */
    useEffect(() => {
        if (!CorporationUtils.isEnableSettingMultiLanguage(corporationDetail)) return;
        const renderedPostList = [
            ...(chatPostByChatThreadIdList || []),
            ...(chatPostUnsentByChatThreadIdList || [])
        ];
        initChatPostOnDemand({
            setChatPostOnDemand,
            chatThreadId,
            threadType: selectThread?.threadType,
            postList: renderedPostList,
            ticketOutline: generateTicketOutlineOnTabChat(ticketInfo),
            ticketId: ticketInfo?.id,
            threadChatList: !Utils.isEmptyArray(threadChatList)
                ? threadChatList.map(t => t?.data).filter(t => !Utils.isEmptyObject(t))
                : [{...selectThread}]
        });
    }, [
        corporationDetail,
        chatThreadId,
        chatPostByChatThreadIdList,
        chatPostUnsentByChatThreadIdList,
        isShowAllChatPost,
        selectThread?.threadType,
        ticketInfo
    ]);

    /**
     * Auto-translate messages that arrive while a thread is already ON (CHT-005 §4.4).
     * Driven by the atom: when init merges a new untranslated message into an ON
     * thread, this triggers its translation. The handler skips threads that are
     * translating and messages already in flight, so it does not loop.
     *
     * Debounced (batching): instead of firing a request as soon as one message
     * arrives, we wait AUTO_TRANSLATE_DEBOUNCE_MS of "silence". Each new message
     * resets the timer, so a burst of messages is collected and sent as ONE request
     * (autoTranslateNewMessages / getListMsgTranslateByThread already gather ALL
     * pending messages of the thread into a single payload).
     */
    useEffect(() => {
        if (!CorporationUtils.isEnableSettingMultiLanguage(corporationDetail)) return;

        // Reset the pending timer whenever the atom changes (a new message arrived
        // or a previous request finished) so a burst is batched together.
        if (autoTranslateTimerRef.current) {
            clearTimeout(autoTranslateTimerRef.current);
        }
        autoTranslateTimerRef.current = setTimeout(() => {
            autoTranslateNewMessages({
                chatPostOnDemand,
                setChatPostOnDemand,
                ticketInfo,
                isOverlap: Boolean(isShowAllChatPost),
                setIsOpenModalReloadPage
            });
        }, TranslationConstant.AUTO_TRANSLATE_DEBOUNCE_MS);

        return () => {
            if (autoTranslateTimerRef.current) {
                clearTimeout(autoTranslateTimerRef.current);
            }
        };
    }, [corporationDetail, chatPostOnDemand, ticketInfo]);

    /**
     * Check display ticket headline by sharedRange
     */
    const checkDisplayTicketHeadLine = () => {
        if (selectThread?.hiddenTicketHeadLine) {
            setIsDisPlayTicketHeadLine(false);
        } else {
            setIsDisPlayTicketHeadLine(true);
        }
    };

    /**
     * Init state:
     * msgContentNewList: content list of msg
     * editedMsgNewList: status edited list of msg
     * statusDeleteMsgNewList: status delete list of msg
     * footprintDetailNewList: footprint list of msg
     */
    useEffect(() => {
        let statusDeleteMsgNewList = { ...statusDeleteMsgList };
        let msgContentNewList = { ...msgContentList };
        let editedMsgNewList = { ...editedMsgList };
        let footprintDetailNewList = { ...footprintDetailList };

        let chatPostAllListClone = cloneDeep(sortByCreatedAtAndSeqAsc(chatPostAllList));
        let msgRefNewList = chatPostAllListClone.reduce((refsObj, msg) => {
            refsObj[msg.id] = createRef();
            msgContentNewList[msg.id] = msg.content;
            editedMsgNewList[msg.id] = Utils.isEmptyArray(msg.history) ? false : true;
            statusDeleteMsgNewList[msg.id] = msg.status;
            footprintDetailNewList[msg.id] = Utils.isEmptyArray(msg.footprintListDetail) ? 0 : msg.footprintListDetail.length;
            return refsObj;
        }, {});

        setMsgRefList(msgRefNewList);
        setStatusDeleteMsgList(statusDeleteMsgNewList);
        setMsgContentList(msgContentNewList);
        setEditedMsgList(editedMsgNewList);
        setFootprintDetailList(footprintDetailNewList);
    }, [chatPostAllList]);


    /**
     * Init observer: footprint, auto scroll last msg (scroll position itself is owned by useKeepChatScrollOnViewChange)
     */
    useEffect(() => {
        // init observer footprint
        const observerFootprint = initObserverFootprint(API, msgRefList, userDetail, chatPostAllList);

        // init observer last msg
        const observerLastMsg = initObserverLastMsg(panelId, chatThreadId, isCreateNewMsg, setIsCreateNewMsg, scrollToBottom);

        // Cleanup the observer if component unmount
        return () => {
            observerFootprint && observerFootprint.disconnect();
            observerLastMsg && observerLastMsg.disconnect();
        };
    }, [msgRefList, chatPostAllList, isCreateNewMsg, scrollToBottom]);

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }
    window.onClickUrlViewTicketFromQAChatThread = onClickUrlViewTicket;

    const onHandleClickDetailEmail = (event, post) => {
        setTriggerEmailTicket({open: true, ticketId: post?.ticketId});
    }

    const onHandleClickOpenReplyEmail = (event, post) => {
        if (isDisableLink) return;
        // post = null;
        if(post && post?.ticketId) {
            setTriggerOpenReplyEmail({open: true, ticketId: post?.ticketId, 
                triggerData: {defaultBody: JSON.stringify(infoChatInputValue?.content)}});
        }else{
            // Open ticket oririn if have no latest customer message
            setTriggerOpenReplyEmail({open: true, ticketId: 'origin', 
                triggerData: {defaultBody: JSON.stringify(infoChatInputValue?.content), isOriginTicket: true}});
        }
    }

    const reloadTicketDetail = () => {
        updateHelpdeskTicketDetailByTicketId(panelList, setPanelList, ticketInfo.id);
    };

    /**
     * Render email ticket action : detail link and status
     */
    const renderDeliverMsgActions = (post, isAlignLeft) => {
        if(isEmailTicket(ticketInfo, selectThread)) {
            return <></>;
        }

        if (isTelephoneEscalationThread) {
            return <></>;
        }

        let isDisableDeliver =
            Utils.isAnonymousQATicketFromLiveChat(ticketInfo) &&
            (Utils.isAnonymousQAEndLiveChatTicket(ticketInfo) ||
                Utils.isAnonymousQAExpireLiveChat(ticketInfo));

        if (
            ![
                Constant.TICKET_TYPE.EXTERNAL_QA,
                Constant.TICKET_TYPE.INTERNAL_QA,
                Constant.TICKET_TYPE.DELEGATE,
                Constant.TICKET_TYPE.ESCALATION,
                Constant.TICKET_TYPE.QA,
                Constant.TICKET_TYPE.BROADCAST_CHILD,
                Constant.TICKET_TYPE.BROADCAST_PARENT,
                Constant.TICKET_TYPE.NOTICE,
                Constant.TICKET_TYPE.TELEPHONE
            ].includes({...ticketInfo}?.ticketType)
        ) {
            return <></>;
        }
        // For 重ね表示 logic , do not show email action when message is created in internal chat
        if (post?.colorTabThread === Constant.COLOR_THREAD_CHAT.INTERNAL_TAB) {
            return <></>;
        }

        // Mess is deleted
        if (isDeleteMsg(post, chatPostAllList) || isUploadingFileMsg(post)) {
            return <></>;
        };

        let emailStatus = '';
        let statusDescript = '';

        if (
            [Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD, Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD].includes(selectThread.threadType) &&
            { ...ticketInfo }.affiliationProject === projectInuseDetail.id && 
            post.affiliationProject === projectInuseDetail.id
        ) {
            if (post?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER) {
                statusDescript = trI18n('MESSAGE_UNSENT_STATUS');
            } else {
                statusDescript = trI18n('MESSAGE_SENT_STATUS');
                emailStatus = 'email-status-sent';
            }
        }


        if({...customerReferenceThread}.id === {...selectThread}.id || selectThread.threadType === Constant.THREAD_CHAT_TYPE.INTERNAL_THREAD 
            || post.chatThreadId === {...customerReferenceThread}?.id ||  post.chatThreadId === {...internalThread}?.id || {...ticketInfo}.affiliationProject !== projectInuseDetail.id
         ){
            return <></>;
        }

        let alignClass = 'emailticket-actions';
        if (!isAlignLeft) alignClass = `${alignClass} emailaction-right`;
        let deliverIconClassName = `email-undeliver cursor-pointer`;
        let toolTipText = trI18n('SEND_TO_CUSTOMER');
        if (isDisableDeliver) {
            toolTipText = '';
            deliverIconClassName = `email-undeliver cursor-default`;
        }
        return (
            
                <div className={alignClass}>
                    {post?.deliverInfo?.status == Constant.DELIVER_STATUS.UNDELIVER && (
                        <div
                            className={deliverIconClassName}
                            onClick={() => {
                                if (isDisableDeliver) return;
                                let dataForLog = {
                                    selectThread,
                                    API,
                                    corporationDetail,
                                    projectInuseDetail,
                                    ticketInfo
                                };
                                deliverMsg(
                                    post.id,
                                    post.ticketId,
                                    userDetail,
                                    {setIsLoading,
                                    setIsOpenModalReloadPage,
                                    reloadTicketDetail,
                                    projectInuseDetail},
                                    ticketInfo,
                                    dataForLog,
                                    post,
                                    selectThread,
                                    setIdMessageRendering
                                );
                            }}
                        >
                            <Tooltip
                                title={toolTipText}
                                placement="bottom"
                                arrow
                            >
                                <img src="/assets/image/chat_send.svg" alt="" />
                            </Tooltip>
                        </div>
                    )}
                    {emailStatus && <div ><img className='check-mark-icon-sent-message' src="/assets/image/check-mark-icon.svg" alt="" /></div>}
                    <div className={emailStatus}>{statusDescript}</div>
                </div>
        );
    };

    /**
     * Render email ticket action : detail link and status
     */
    const renderEmailActions = (post, isAlignLeft) => {
        // Only ticket email is displayed
        if(!isEmailTicket(ticketInfo, selectThread)) {
            return <></>;
        }
        // For 重ね表示 logic , do not show email action when message is created in internal chat
        if(post?.colorTabThread === Constant.COLOR_THREAD_CHAT.INTERNAL_TAB) {
            return <></>;
        }

        // Mess is deleted
        if(isDeleteMsg(post, chatPostAllList)) {
            return <></>;
        }

        let alignClass = 'emailticket-actions';
        if(!isAlignLeft) alignClass = `${alignClass} emailaction-right`;

        let statusDescript = '';
        let emailStatus = '';
        if(post?.deliverInfo?.status) {
            statusDescript = trI18n('EMAIL_STATUS_SENT');
            emailStatus = 'email-status-sent';
        }else {
            statusDescript = trI18n('EMAIL_STATUS_UNSEND');
        }

        let showStatus = true;
        if(Utils.isEmptyString(post?.affiliationProject) || post?.affiliationProject === 'customer') {
            showStatus = false;
        }

        let classNameForUnDeliverBtn = `email-undeliver`;
        if (post?.ticketId === ticketInfo.id) {
            classNameForUnDeliverBtn = `${classNameForUnDeliverBtn} disabled-elm`;
        } else {
            classNameForUnDeliverBtn = `${classNameForUnDeliverBtn} cursor-pointer`;
        }


        return <>
            <div className={alignClass}>
                <div className='email-detail'>
                    <span className='email-detail-hyperlink' onClick={(e) => onHandleClickDetailEmail(e, post)}>{trI18n('EMAIL_DETAIL')}</span>
                </div>
                {showStatus && (post?.deliverInfo?.status ? 
                    <div class="email-deliver">
                        <img src="/assets/image/icon-email-status-deliver.svg" alt='' />
                    </div>
                    : 
                    <div 
                        className={classNameForUnDeliverBtn + ` ${isDisableLink ? 'email-detail-hyperlink-disable' : ''}`}
                        onClick={() => {
                            if (isDisableLink) return;
                            if (post?.ticketId === ticketInfo.id) return;
                            let dataForLog = {
                                selectThread,
                                API,
                                corporationDetail,
                                projectInuseDetail,
                                ticketInfo
                            }
                            deliverEmailMsg(
                                post.id,
                                post.ticketId,
                                userDetail,
                                setIsLoading,
                                setIsOpenModalReloadPage,
                                reloadTicketDetail,

                                dataForLog
                            );
                        }}
                    >
                        <Tooltip title={trI18n('SEND_EMAIL_TO_CUSTOMER')} placement='bottom' arrow >
                            <img src="/assets/image/icon-email-status-undeliver.svg" alt='' />
                        </Tooltip>
                    </div>
                )}
                {showStatus && <div className={emailStatus}>{statusDescript}</div>}
            </div>
        </>
    }

    /**
     * Render block msg
     */
    const renderChatListByUser = (postList, isAlignLeft = true, isCenter = false) => {

        if ([Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo.ticketType)) {
            postList = postList.filter(item => item.status !== Constant.CHAT_POST_STATUS.DELETE_READ)
        }

        if (typeof postList === 'undefined' || postList.length === 0) {
            return null;
        }

        // Display system msg
        if (isCenter) {
            let postContent = postList[0];
            const isTwilioCallEvent = postContent.postType === Constant.POST_TYPE.TWILIO_CALL_EVENT && postContent.creatorId === 'system';
            return (
                <div className={`chatBox-msg-center ${isTwilioCallEvent ? 'twilio-call-event' : ''}`}>
                    <span className="line-endchat">
                        <h2 className={isTwilioCallEvent ? 'twilio-call-event-text' : ''}>
                            <span>{tr(postContent.content)}</span>
                        </h2>
                    </span>
                </div>
            )
        }

        let contentChatList = [];

        const isDisplayBtnEdit = (item) => {
            if (!ticketInfo || !selectThread || !userDetail) {
                return false;
            }
            if (isAIAssistantThread(selectThread)) return false;
            
            const commonConditions =
                item.chatThreadId === selectThread.id &&
                !isArchive &&
                Utils.isEmptyString(ticketInfo?.deletedAt);

            if (
                !Utils.isEmptyObject(customerReferenceThread) &&
                item?.chatThreadId === customerReferenceThread?.id
            )
                return false;

            if (
                [Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo?.ticketType) &&
                selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER
            ) {
                const isMessageUndelivered = isEmailMessUndeliver(ticketInfo, selectThread, item);
                return isMessageUndelivered ? commonConditions : false;
            }

            if(item?.deliverInfo?.status === Constant.DELIVER_STATUS.UNDELIVER){
               return item.affiliationProject === selectedProjectId && commonConditions
            }
        
            return commonConditions && item.creatorId === userDetail.id;
        }

        const isDisplayBtnDelete = (item) => {
            if (!ticketInfo || !selectThread || !userDetail) {
                return false;
            }
            if (isAIAssistantThread(selectThread)) return false;

            if (item.postType === Constant.POST_TYPE.MSG_VOICE) {
                // can not delete voice message
                return false;
            }
        
            const commonConditions = (
                item.chatThreadId === selectThread.id &&
                !isArchive &&
                Utils.isEmptyString(ticketInfo?.deletedAt)
            );

            if (
                !Utils.isEmptyObject(customerReferenceThread) &&
                item?.chatThreadId === customerReferenceThread?.id
            )
                return false;
        
            if (
                [Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo?.ticketType) &&
                selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER
            ) {
                const isMessageUndelivered = isEmailMessUndeliver(ticketInfo, selectThread, item);
                return isMessageUndelivered ? commonConditions : false;
            };

            if(item?.deliverInfo?.status === Constant.DELIVER_STATUS.UNDELIVER){
                return item.affiliationProject === selectedProjectId && commonConditions
             }
            
            return commonConditions && item.creatorId === userDetail.id;
        }

        postList.forEach((item) => {
            if (Utils.isEmptyObject(msgRefList[item.id])) {
                msgRefList[item.id] = createRef();
            }
            if (item.postType !== Constant.POST_TYPE.MSG) {
                item.type = Constant.S3_FILE_TYPE.CHAT_POST_FILE;
                item.currentChatThreadId = selectThread.id;
                item.sharedRange = selectThread.sharedRange;
                item.chatThreadType = selectThread.threadType;
                item.ticketId = ticketIdSelected
            }

            let contentIncludeHtml = '';
            if(isEmailTicket(ticketInfo, selectThread)) {
                contentIncludeHtml = getContentChatPostEmail(item, props.userChatList, isAlignLeft,true);
            }else {
                contentIncludeHtml = getContentChatPost(item, props.userChatList, isAlignLeft,true);
            }
            let colorStackChat = '';
            let borderColorStackChat = '';
            let isWarningMessage = false

            //set color chat list
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT && !isAlignLeft) {
                colorStackChat = 'color-stack-customer'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.INTERNAL_CHAT && !isAlignLeft) {
                colorStackChat = 'color-stack-internal'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.REFERENCE_CHAT) {
                colorStackChat = 'color-stack-reference'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.AI_ASSISTANT_CHAT && !isAlignLeft) {
                colorStackChat = 'color-stack-ai-assistant'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT && !isAlignLeft) {
                colorStackChat = 'color-stack-escalate'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.INTERNAL_CHAT && isAlignLeft) {
                colorStackChat = 'color-stack-internal-sender'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT && isAlignLeft) {
                colorStackChat = 'color-stack-customer-sender'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT && isAlignLeft) {
                colorStackChat = 'color-stack-escalate-sender'
            }
            if (item?.colorChatThread === Constant.COLOR_THREAD_CHAT.AI_ASSISTANT_CHAT && isAlignLeft) {
                colorStackChat = 'color-stack-ai-assistant-sender'
            }

            
            const MCP_WARNING_PREFIX = SdeskMcpConstant.MCP_WARNING_PREFIX;
            const isAssistantMessage = item?.chatThreadId === aiAssistantThread?.id;
            if (isAssistantMessage && item?.content.startsWith(MCP_WARNING_PREFIX)) {
                item.content = item?.content?.replace(MCP_WARNING_PREFIX, '')
                isWarningMessage = true
                colorStackChat = 'mcp-warning-message';
            }


            if(isShowAllChatPost) {
                //set border chat thread focus
                if(item?.chatThreadId === selectThread.id) {
                    if(item?.colorTabThread === Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB) {
                        borderColorStackChat = 'border-color-stack-customer'
                    }
                    if(item?.colorTabThread === Constant.COLOR_THREAD_CHAT.INTERNAL_TAB) {
                        borderColorStackChat = 'border-color-stack-internal'
                    }
                    if(item?.colorTabThread === Constant.COLOR_THREAD_CHAT.REFERENCE_TAB) {
                        borderColorStackChat = 'border-color-stack-reference'
                    }
                    if(item?.colorTabThread === Constant.COLOR_THREAD_CHAT.ESCALATE_TAB) {
                        borderColorStackChat = 'border-color-stack-escalate'
                    }
                    if(item?.colorTabThread === Constant.COLOR_THREAD_CHAT.AI_ASSISTANT_TAB) {
                        borderColorStackChat = 'border-color-stack-ai-assistant'
                    }
                }
            }

            const attachmentFiles = getChatAttachmentFiles(item?.attachFiles, uploadedFiles[item.id]);
            const images = attachmentFiles.filter(file => isChatImageAttachment(file));
            const files = attachmentFiles.filter(file => !isChatImageAttachment(file));

            const chatBoxToolProps = {
                chatPostAllList,
                ticketInfo,
                item,
                setChatPostShowFlagMsgCopyMsgId,
                isDisableLink,
                genMessageCopyShortLink,
                isDisplayBtnEdit,
                setIsOpenModalReloadPage,
                setOpenModalDeleteMsg,
                selectThread,
                isDisplayBtnDelete,
                setReactionPopoverId,
                setReactionPopover,
                reactionId,
                isEnableChat,
                editedMsgList,
                setIsOpenHistoryDialog,
                setIsLoadingHistoryList,
                setHistoryList,
                setMsgEditSelected,
                userChatList: props.userChatList,
                setIsShowModalEditMsg,
                msgRefList,
                setChatPostUpdate,
                chatPostShowFlagMsgCopyMsgId,
                userSetting: userDetail?.userSetting,
            };

            contentChatList.push(
                <div className="chatBox-text"
                    id={item.id}
                    ref={msgRefList[item.id]}>
                    {!isDeleteMsg(item, chatPostAllList) && !!images?.length && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, justifyContent: !isAlignLeft ? 'flex-end' : 'flex-start', marginBottom: 10 }}>
                            {images.map(itemFile => (
                                <FlagMessageCopy
                                    key={itemFile.id}
                                    title={trI18n('MSG-COPY-SHARELINK')}
                                    placement="top-end"
                                    open={!!chatPostShowFlagMsgCopyMsgId[itemFile?.id]}
                                >
                                    <div className={`attach-img-chatpost ${focusedMsgId === item.id && 'focused-msg'}`} style={{ borderRadius: 10, position: 'relative' }}>
                                        <AttachFile
                                            key={itemFile.id}
                                            chatPost={item}
                                            detailTicket={ticketInfo}
                                            file={itemFile}
                                            isAlignLeft={isAlignLeft}
                                            isImageLayout={true}
                                            setIsShowPopupLogout={setIsShowPopupLogout}
                                        />
                                        {!Utils.isEmptyString(item.id) && (
                                            <ChatBoxToolTicket
                                                {...chatBoxToolProps}
                                                itemFile={itemFile}
                                            />
                                        )}
                                    </div>
                                </FlagMessageCopy>
                            ))}
                        </div>
                    )}
                    {!isDeleteMsg(item, chatPostAllList) && !!files?.length && (
                        <div className="chat-message-attachments">
                            {files.map((itemFile, index) => (
                                <div
                                    key={itemFile.id || itemFile.key || itemFile?.fileData?.name || index}
                                    className="chatBoxContent"
                                    data-cy="chat-message-content"
                                >
                                    <span className="chatBox-label">
                                        <FlagMessageCopy
                                            title={trI18n('MSG-COPY-SHARELINK')}
                                            placement="top-end"
                                            open={!!chatPostShowFlagMsgCopyMsgId[itemFile?.id]}
                                        >
                                            <span
                                                className={`chatBox-txt chat-message-attachment-row attach-img-chatpost ${focusedMsgId === item.id && 'focused-msg'} ${colorStackChat}`}
                                            >
                                                <AttachFile
                                                    chatPost={item}
                                                    detailTicket={ticketInfo}
                                                    file={itemFile}
                                                    isAlignLeft={isAlignLeft}
                                                    setIsShowPopupLogout={setIsShowPopupLogout}
                                                />
                                                {!Utils.isEmptyString(item.id) && (
                                                    <ChatBoxToolTicket
                                                        {...chatBoxToolProps}
                                                        itemFile={itemFile}
                                                    />
                                                )}
                                            </span>
                                        </FlagMessageCopy>
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="chatBoxContent" data-cy="chat-message-content">
                        {item.insertFail && <WarningIcon color="error" size="small" style={{ margin: 'auto' }} />}
                        {!isDeleteMsg(item, chatPostAllList) && <span className="chatBox-label">
                        {!Utils.isEmptyString(item.content) && (
                            <FlagMessageCopy  
                                    title={trI18n('MSG-COPY-SHARELINK')}
                                    placement="top-end"
                                    open={!!chatPostShowFlagMsgCopyMsgId[item?.id]}
                            >
                                        <span className={`${focusedMsgId === item.id && 'focused-msg'} ${!isWarningMessage ? 'chatBox-txt' : ""}  ${colorStackChat} ${borderColorStackChat}`} onMouseEnter={() => getDelegateUserDetail(API, item, setDelegateUserDetail)}>
                                            {(Utils.isEmptyString(item.id) && !item.insertFail) || item.isLoading ?
                                                (
                                                    <main style={{display: 'flex', alignItems: 'center'}}>
                                                        <CircularProgress size={14} color={'inherit'} style={{ marginRight: '5px' }} />
                                                        <ChatPostTranslationView
                                                            threadId={item.chatThreadId || chatThreadId}
                                                            selectThread={selectThread}
                                                            postId={item.id}
                                                            mention={item?.mention}
                                                            userChatList={props.userChatList}
                                                            isRichText={isEmailTicket(ticketInfo, selectThread)}
                                                            isAlignLeft={isAlignLeft}
                                                        >
                                                            {renderChatRecord({...item, content: contentIncludeHtml, rawContent: item?.content})}
                                                        </ChatPostTranslationView>
                                                    </main>
                                                ) : (
                                                    <ChatPostTranslationView
                                                        threadId={item.chatThreadId || chatThreadId}
                                                        selectThread={selectThread}
                                                        postId={item.id}
                                                        mention={item?.mention}
                                                        userChatList={props.userChatList}
                                                        isRichText={isEmailTicket(ticketInfo, selectThread)}
                                                        isAlignLeft={isAlignLeft}
                                                    >
                                                        {renderChatRecord({...item, content: contentIncludeHtml, rawContent: item?.content})}
                                                    </ChatPostTranslationView>
                                                )
                                            }
                                            {(isShowAllChatPost || (!isShowAllChatPost && selectThread && selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER)) &&
                                                item.delegateUserId &&
                                                !Utils.isEmptyString(item.delegateUserId) && getDelegateDetail(delegateUserDetail)}
                                            {!Utils.isEmptyString(item.id) && (
                                                <ChatBoxToolTicket 
                                                    {...chatBoxToolProps}
                                                />
                                            )}
                                            {item.postType === Constant.POST_TYPE.MSG_VOICE && (
                                                    <div className="chatBox-sub">
                                                        <p>{trI18n('MSG_TRANSCRIPT_TOOLTIP')}</p>
                                                    </div>
                                            )}
                                        </span>
                            </FlagMessageCopy>
                            )}
                            {!isDeleteMsg(item, chatPostAllList) && <div className="chatBox-view">
                                {/* start footprint */}
                                {(getFootprintNumber(item.footprintListDetail, footprintDetailList[item.id]) > 0) &&
                                    <div className="numberView">
                                        <Button
                                            className={`numberView-btn ${!isShowReadNumber(userDetail, ticketInfo) ? 'disable' : ''}`}
                                            aria-describedby={id}
                                            variant="contained" onClick={e => {
                                                if(isShowReadNumber(userDetail, ticketInfo)) {
                                                    setFootPrintPopoverId(item.id);
                                                    onClickPopoverFootprint(e, item,
                                                        setFootPrintPopover,
                                                        chatPostAllList,
                                                        setUserFootprintList);
                                                }
                                            }}
                                            disabled={isDisabledShowReadList(userDetail, ticketInfo)}
                                        >
                                            <img src="/assets/image/footprints.svg" alt="" />
                                        </Button>
                                        <Popover
                                            className="numberView-sub"
                                            id={id}
                                            open={openPopover && footPrintPopoverId === item.id}
                                            anchorEl={footPrintPopover}
                                            onClose={e => setFootPrintPopover(null)}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                            }}
                                        >
                                            <div className="listView" id={`footprint_id_${item.id}`}>
                                                <h3 className="title">{tr('あしあとを付けた人')}</h3>
                                                <ul>
                                                    {userFootprintList}
                                                </ul>
                                            </div>
                                        </Popover>
                                    </div>
                                }
                                {(getFootprintNumber(item.footprintListDetail, footprintDetailList[item.id]) > 0)
                                    && isShowReadNumber(userDetail, ticketInfo) &&
                                    <span className="number">{
                                        getFootprintNumber(item.footprintListDetail, footprintDetailList[item.id])
                                    }</span>
                                }
                            </div>
                            }
                        </span>
                        }
                        {isShowDeleteTmpMsg(item, statusDeleteMsgList, chatPostAllList) && 
                            isShowDeleteTmpMsgWithAlignRule(isAlignLeft, item, {ticketInfo: ticketInfo, userDetail: userDetail}) &&
                            <span className="chatBox-label">
                                <span className={`chatBox-txt ${colorStackChat} ${borderColorStackChat}`}>
                                    <span className="chatBox-label chatBox-label--delete">{trI18n('MSG_DELETED')}</span>
                                </span>
                            </span>
                        }

                        {!isDeleteMsg(item, chatPostAllList) && <ListReactionByChatPost
                            chatPost={item}
                            isAlignLeft={isAlignLeft}
                            {...args}
                            isDisableLink={isDisableLink}
                        />}
                        {renderEmailActions(item, isAlignLeft)}
                        {renderDeliverMsgActions(item, isAlignLeft)}
                    </div>
                    {renderStatusSendMsgError(item)}
                    {/* start modal edit msg */}
                    {!Utils.isEmptyObject(isShowModalEditMsg[item.id]) && isShowModalEditMsg[item.id] &&
                        !uploadedFiles[item.id]?.find(i => !i?.shortKey) &&
                        <EditChatPost
                            {...args}
                            itemChatPost={item}
                            notShowMention={isEmailTicketCustomerChatthread(ticketInfo, selectThread)}
                            isEmailMessUndeliver = {isEmailMessUndeliver(ticketInfo, selectThread, item)}
                            ticketInfo={ticketInfo}
                            reloadTicketDetail={reloadTicketDetail}
                            selectThread={selectThread}
                            attachFiles={item?.attachFiles || uploadedFiles[item.id] || []}
                            onEditSuccess={() => clearUploadedFilesByPost(setUploadedFiles, item.id)}
                        />}
                    {/* end modal edit msg */}
                    <ReactionChatPost chatPost={item} {...args} />
                </div>
            );
        });
        let post = postList[0];
        let messTime = post?.createdAt;
        if(!Utils.isEmptyString(post?.deliverInfo?.deliverAt)) {
            messTime = post?.deliverInfo?.deliverAt;
        }
        let avatar = post.userDetailPostMsg.avatar;
        let isAnonymousMsg = false;
        let displayName = post.postType === Constant.POST_TYPE.MSG_VOICE
            ? Utils.getDisplayUserNameMsgVoice( post, ticketInfo )
            : Utils.getFullNameOfUserWithCorporationStatus(
                Constant.LANGUAGE_TYPE.JP,
                post.userDetailPostMsg,
                '',
                ticketInfo
            );
        if(Utils.isEmptyString(displayName.trim()) && isEmailTicket(ticketInfo, selectThread)) {
            displayName = post.userDetailPostMsg.mail;
        }

        if (post?.userDetailPostMsg?.id?.includes('anonymous_')) {
            displayName = tr('未登録カスタマー');
            isAnonymousMsg = true;
        }
        
        const aiOperatorInfo = getAiOperatorInfoFromPost(post);
        if (aiOperatorInfo && !Utils.isEmptyString(aiOperatorInfo.aiName)) {
            displayName = aiOperatorInfo.aiName; // Use aiName as displayName
        }

        let prjSendMailName = '';
        // Fix for email ticket case prj send to prj: always display prj setting name left side
        if (
            isAlignLeft &&
            ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL &&
            selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER &&
            ticketInfo?.metaData
        ) {
            let ticketMetaData = Utils.convertJSONDataToObject(ticketInfo?.metaData);
            if (ticketMetaData?.fromData?.projectId && ticketMetaData?.fromData?.originName) {
                prjSendMailName = ticketMetaData?.fromData?.originName;
                if (prjSendMailName) {
                    displayName = `${displayName} (${prjSendMailName})`;
                }
            }
        }

        let chatBoxDiv = isShowBlockMsg(postList, statusDeleteMsgList, {ticketInfo: ticketInfo, userDetail: userDetail}) ? (
            <div
                className={isAlignLeft ? 'chatBox' : 'chatBox chatBox--change'}
                key={post.id}
                data-cy={isAlignLeft ? 'chat-message-box-left' : 'chat-message-box-right'}
            >
                <div className="chatBox-info">
                    {isAlignLeft && (
                        <div className="chatBox-thumb">
                            <img src={avatar} alt="" />
                        </div>
                    )}
                    <div className="chatBox-content">
                        <div className="chatBox-dateTime">
                            {isShowAllChatPost && <OverFlowTooltipWithTabsMui value={`${isAlignLeft ? 'From' : 'To'}: ${post?.threadName}`} className="place-project"/>}
                            {isShowAllChatPost && (<div className='circle-chat'></div>)}
                            <OverFlowTooltipWithTabsMui
                                value={displayName}
                                className={`name ${isShowAllChatPost && 'name-showAll'}`}
                            />
                            <span className="time">
                               {formatUserDateTime(messTime, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}
                            </span>
                            {isEditedMsg(editedMsgList, post) && post?.deliverInfo?.status != 0 && (
                                <span className="edited">{tr('Edited')}</span>
                            )}
                        </div>
                        {contentChatList}
                    </div>
                </div>
            </div>
        ) : (
            <div
                className={isAlignLeft && 'chatBox'}
                key={post.id}
                data-cy={isAlignLeft && 'chat-message-box-left'}
            >
                <div className="chatBox-info">
                    {isAlignLeft && (
                        <>
                            <div className="chatBox-thumb">
                                <img src={avatar} alt="" />
                            </div>
                            <div className="chatBox-content">
                                <div className="chatBox-dateTime">
                                    <OverFlowTooltipWithTabsMui
                                        value={isAnonymousMsg ? tr('未登録カスタマー') : Utils.getFullNameOfUserWithCorporationStatus(
                                            Constant.LANGUAGE_TYPE.JP,
                                            post.userDetailPostMsg,
                                            '',
                                            ticketInfo
                                        )}
                                        className="name"
                                    />
                                    <span className="time">
                                        {formatUserDateTime(
                                            messTime,
                                            'YYYY/MM/DD HH:mm',
                                            userDetail?.userSetting
                                        )}
                                    </span>
                                </div>
                                {contentChatList}
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
        return chatBoxDiv;
    };

    const renderChatRecord = chatRecord => {
        // can be added more condition to render by richtext editors
        const isRenderByRichEditor = isEmailCustomerThread(ticketInfo, selectThread?.threadType);
        const isMessageLoading =
            (Utils.isEmptyString(chatRecord?.id) && !chatRecord?.insertFail) ||
            chatRecord?.isLoading;
        const isAssistantMessage = chatRecord?.chatThreadId === aiAssistantThread?.id;
        const markdownContent = chatRecord?.rawContent ?? chatRecord?.content ?? '';

        if (isAssistantMessage) {
            return (
                <>
                    {!!markdownContent?.length && (
                        <div className={`${!isMessageLoading && 'displayMessage'}`}>
                            <AIResponse
                                data={{ content: markdownContent }}
                                isWaitingChat={false}
                                isPublicSite={false}
                            />
                        </div>
                    )}
                </>
            );
        }

        // it's condition need render by richtext editor
        if (isRenderByRichEditor)
            return (
                <>
                    <div
                        id={`ckbox-${chatRecord?.id}`}
                        data-cy="richtext-editor"
                        className={`
                        editor sdesk-editor editor-view ckeditor5-readonly chat-message ${!isMessageLoading &&
                            'displayMessage'}
                        `}
                    >
                        <CKEditor
                            editor={window.CKEDITOR.ClassicEditor}
                            data={chatRecord?.content}
                            config={CkeditorConfiguration}
                            onReady={editor => {
                                editor.ui.view.toolbar.element.style.display = 'none';
                                editor.enableReadOnlyMode(editor.id);
                            }}
                            onFocus={(event, editor) => {
                                window.editor = editor;
                                document
                                    .querySelectorAll(
                                        `.editor .ck.ck-sticky-panel__content > .ck.ck-toolbar[aria-label="Editor toolbar"]`
                                    )
                                    .forEach(el => {
                                        el.style.display = 'none';
                                    });
                                editor.ui.view.toolbar.element.style.display = 'block';
                            }}
                        />
                    </div>
                </>
            );

        // render normal
        return (
            <>
            {!!chatRecord?.content?.length && (
                <div
                    className={`${!isMessageLoading && 'displayMessage'}`}
                    dangerouslySetInnerHTML={{ __html: chatRecord?.content }}
                ></div>
            )}
            </>
        );
    };

    const genMessageCopyShortLink = messageChat => {
        return `${window.location.origin}/${Utils.getUrlShortShareLinkTicket({
            chatPostId: messageChat?.id,
            shortKey: ticketOriginInfor?.dataShareLink?.shortKey,
            subDomain: ticketOriginInfor?.dataShareLink?.generateLinkCorporationDomain,
            type: ticketOriginInfor?.dataShareLink?.type
        })}`;
    };
    
    /**
     * Render chat post list
     */
    const renderChatList = () => {
        // sort array
        let postDetailListSorted = [];
        if(isEmailTicket(ticketInfo, selectThread)) {
            postDetailListSorted = sortChatpostListInEmailTicket(chatPostByChatThreadIdList);
        }else {
            postDetailListSorted = sortByUpdatedAtAndSeqAsc(
                JSON.parse(JSON.stringify(chatPostByChatThreadIdList))
            );
        }

        // group msg by date, createdAt
        let blockMsgHash = Object.create(null);
        let blockMsgList = [];
        let prevUserPostMsg = '';

        postDetailListSorted = postDetailListSorted.filter(post => {
            if (isDeleteMsg(post, chatPostAllList)) {
                return true; // luôn giữ message đã xóa, không loại khỏi block
            }


            const isMsgFile = [
                Constant.POST_TYPE.MSG_FILES, 
                Constant.POST_TYPE.FILE, 
                Constant.POST_TYPE.MSG_VOICE, 
                Constant.POST_TYPE.IMAGE
            ]
            
            const isEmptyPost =
                Utils.isEmptyArray(post.attachFiles) && 
                Utils.isEmptyString(post.content) &&
                Constant.TICKET_TYPE.EMAIL !== ticketInfo?.ticketType && 
                !isMsgFile.includes(post.postType);
                
            return !isEmptyPost;
        });

        postDetailListSorted.forEach(post => {
            let createdAt = Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(post?.deliverInfo?.deliverAt || post.createdAt);
            let key = `${post.userDetailPostMsg.id}/${createdAt}`;
            if (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) {
                let deliverStatus = post?.deliverInfo?.status ? Constant.DELIVER_STATUS.DELIVER : Constant.DELIVER_STATUS.UNDELIVER;
                key = `${post.userDetailPostMsg.id}/${createdAt}/${deliverStatus}`;
            }

            if (
                !blockMsgHash[key] ||
                prevUserPostMsg !== post.creatorId ||
                !Utils.isEmptyArray(post.history)
                || (isShowAllChatPost && post.chatThreadId !== blockMsgHash[key][0]?.chatThreadId
                )
            ) {
                const isCurrentUserPost =
                    post?.creatorId === userDetail?.id ||
                    post?.userDetailPostMsg?.id === userDetail?.id;
                let isAlignLeft = !isCurrentUserPost;
                if(isEmailTicket(ticketInfo, selectThread)) {
                    if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
                        isAlignLeft = post?.affiliationProject === projectInuseDetail?.id ? false : true;
                    }
                }
                // Check if AI chat post belongs to current project
                const aiOperatorInfo = getAiOperatorInfoFromPost(post);
                if (aiOperatorInfo && aiOperatorInfo.projectId === projectInuseDetail?.id) {
                    // Check by post's chatThreadId, not selectThread — handles 重ね表示 (stacked view) correctly
                    const isPostFromAIAssistantThread = post.chatThreadId === aiAssistantThread?.id;
                    if (isPostFromAIAssistantThread) {
                        // AI Assistant thread: user-sent → right, AI-generated → left
                        isAlignLeft = !isCurrentUserPost;
                    } else {
                        // Training ticket: AI displays on left side (as conversation partner)
                        // Normal telephone ticket: AI displays on right side (as operator)
                        const ticketMetaData = Utils.convertJSONDataToObject(ticketInfo?.metaData);
                        if (ticketMetaData?.telephoneType !== Constant.TICKET_PROPERTY.TRAINING) {
                            isAlignLeft = false;
                        }
                    }
                }
                
                blockMsgHash[key] = [];
                let blockMsg = {
                    isAlignLeft: isAlignLeft,
                    msgList: blockMsgHash[key],
                    // post.content is stored in the DB as the original Japanese text (SystemMessageText.CBOTMSG018).
                    // Compare against I18n.get('CBOTMSG018') to get that same original text, NOT trI18n('CBOTMSG018'):
                    // trI18n translates to the current UI language, so the comparison would fail when the UI is not Japanese.
                    isCenter: (post.postType === Constant.POST_TYPE.END_LIVE_CHAT_MESSAGE && post.content === I18n.get('CBOTMSG018')) || 
                              (post.postType === Constant.POST_TYPE.TWILIO_CALL_EVENT && post.creatorId === 'system') ? true : false
                };
              
                blockMsgList.push(blockMsg);
            }
            prevUserPostMsg = post.creatorId;
            blockMsgHash[key].push(post);
        });
      
        // build msg
        let mgsList = [];
        blockMsgList.forEach(blockMsg => {
            mgsList.push(renderChatListByUser(blockMsg.msgList, blockMsg.isAlignLeft, blockMsg.isCenter));
        });
   
        return mgsList;
    };

    const renderUnSentChatList = () => {
        // sort array
        let postDetailListSorted = [];
        if(isEmailTicket(ticketInfo, selectThread)) {
            postDetailListSorted = sortChatpostListInEmailTicket(chatPostUnsentByChatThreadIdList);
        }else {
            postDetailListSorted = sortByUpdatedAtAndSeqAsc(
                JSON.parse(JSON.stringify(chatPostUnsentByChatThreadIdList))
            );
        }

        // group msg by date, createdAt
        let blockMsgHash = Object.create(null);
        let blockMsgList = [];
        let prevUserPostMsg = '';
        postDetailListSorted.forEach(post => {
            let createdAt = Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(post.createdAt);
            let key = `${post.userDetailPostMsg.id}/${createdAt}`;
            if (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) {
                let deliverStatus = post?.deliverInfo?.status ? Constant.DELIVER_STATUS.DELIVER : Constant.DELIVER_STATUS.UNDELIVER;
                key = `${post.userDetailPostMsg.id}/${createdAt}/${deliverStatus}`;
            }
            if (
                !blockMsgHash[key] ||
                prevUserPostMsg !== post.creatorId ||
                !Utils.isEmptyArray(post.history)
                || (isShowAllChatPost && post.chatThreadId !== blockMsgHash[key][0]?.chatThreadId
                )
            ) {
                const isCurrentUserPost =
                    post?.creatorId === userDetail?.id ||
                    post?.userDetailPostMsg?.id === userDetail?.id;
                let isAlignLeft = !isCurrentUserPost;
                if(isEmailTicket(ticketInfo, selectThread)) {
                    if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
                        isAlignLeft = post?.affiliationProject === projectInuseDetail?.id ? false : true;
                    }
                }
                
                // Check if AI chat post belongs to current project
                const aiOperatorInfo = getAiOperatorInfoFromPost(post);
                if (aiOperatorInfo && aiOperatorInfo.projectId === projectInuseDetail?.id) {
                    // Check by post's chatThreadId, not selectThread — handles 重ね表示 correctly
                    const isPostFromAIAssistantThread = post.chatThreadId === aiAssistantThread?.id;
                    if (isPostFromAIAssistantThread) {
                        // AI Assistant thread: user-sent → right, AI-generated → left
                        isAlignLeft = !isCurrentUserPost;
                    } else {
                        isAlignLeft = false; // Display on right side
                    }
                }
                
                blockMsgHash[key] = [];
                let blockMsg = {
                    isAlignLeft: isAlignLeft,
                    msgList: blockMsgHash[key],
                    // post.content is stored in the DB as the original Japanese text (SystemMessageText.CBOTMSG018).
                    // Compare against I18n.get('CBOTMSG018') to get that same original text, NOT trI18n('CBOTMSG018'):
                    // trI18n translates to the current UI language, so the comparison would fail when the UI is not Japanese.
                    isCenter: (post.postType === Constant.POST_TYPE.END_LIVE_CHAT_MESSAGE && post.content === I18n.get('CBOTMSG018')) || 
                              (post.postType === Constant.POST_TYPE.TWILIO_CALL_EVENT && post.creatorId === 'system') ? true : false
                };
              
                blockMsgList.push(blockMsg);
            }
            prevUserPostMsg = post.creatorId;
            blockMsgHash[key].push(post);
        });
      
        // build msg
        let mgsList = [];
        blockMsgList.forEach(blockMsg => {
            mgsList.push(renderChatListByUser(blockMsg.msgList, blockMsg.isAlignLeft, blockMsg.isCenter));
        });
   
        return mgsList;
    };

    /**
     * If chatthread is email ticket , so sort by deliverInfo.status and deliverAt
     * deliverInfo.status = 1 is always show on top , and deliverAt show in displayMessTime
     */
    const sortChatpostListInEmailTicket = (chatpostList) => {
        let postDetailListSorted = sortByDeliverAtAndSeqAsc(
            JSON.parse(JSON.stringify(chatpostList))
        );
        let deliverChatpostList = [];
        let unDeliverChatpostList = [];
        let internalChatpostList = [];
        let deleteChatpostList = [];
        postDetailListSorted.forEach(post => {
            let customPost = post;
            if(post?.deliverInfo?.status && !Utils.isEmptyString(customPost?.deliverInfo?.deliverAt)) {
                customPost.displayMessTime = post?.deliverInfo?.deliverAt;
                deliverChatpostList.push(customPost);
            }else if(post?.colorTabThread === Constant.COLOR_THREAD_CHAT.INTERNAL_TAB) {
                customPost.displayMessTime = post?.createdAt;
                internalChatpostList.push(customPost);
            }else if(post?.status === Constant.CHAT_POST_STATUS.DELETE_READ) {
                customPost.displayMessTime = post?.createdAt;
                deleteChatpostList.push(customPost);
            } else {
                customPost.displayMessTime = post?.createdAt;
                unDeliverChatpostList.push(customPost);
            }
        });

        let overLapInteralAndDeliver = sortByDisplayMessTimeAndSeqAsc(JSON.parse(JSON.stringify([...deliverChatpostList, ...internalChatpostList, ...deleteChatpostList])));
        // Check if last item of overLapInteralAndDeliver has no deliverAt, so get to another array and overlap with unDeliverChatpostList
        let unOverlapInteralAndDeliver = [];
        let posIndex = 0; // Position of overLapInteralAndDeliver that contain deliver message and internal mess
        for(let index = overLapInteralAndDeliver.length -1 ; index >=0; index--){
            let messObj = overLapInteralAndDeliver[index];
            if(!Utils.isEmptyString(messObj?.deliverInfo?.deliverAt)) {
                posIndex = index + 1;
                break;
            }
            unOverlapInteralAndDeliver.push(messObj);
        }

        if(!Utils.isEmptyArray(overLapInteralAndDeliver)) {
            overLapInteralAndDeliver = overLapInteralAndDeliver.slice(0, posIndex);
        }

        // With undeliver message , resort by createAt
        unDeliverChatpostList = sortByCreatedAtAndSeqAsc(
            JSON.parse(JSON.stringify([...unDeliverChatpostList, ...unOverlapInteralAndDeliver]))
        );
        return [...overLapInteralAndDeliver, ...unDeliverChatpostList];
    }

    /**
     * Find latest customer message 
     */
    const findLatestCustomerMess = (chatpostList) => {
        let latestCustomerMessage = null;
        chatpostList?.map((post) => {
            if(post?.affiliationProject === 'customer') {
                latestCustomerMessage = post;
            }
        });
        setLatestCustomerMess(latestCustomerMessage);
    }


    /**
     * Handle datetime input of post msg from picker
     */
    const handlePostCreatedAtDateTimeOnChange = (dateValue) => {
        const updatedItem = {
            ...infoChatInputValue,
            postCreatedAtDateTime: dateValue ? moment(dateValue).format('YYYY/MM/DD HH:mm') : ''
        }
        
        // Validate dateValue if it exists and isDelegateThread
        if (dateValue && isCheckDelegatePostMsg && !isPostCreatedAtCurrentTime) {
            const dataValidate = {
                isDelegateThread: isCheckDelegatePostMsg,
                isPostCreatedAtCurrentTime: false,
                postCreatedAtDateTime: updatedItem.postCreatedAtDateTime,
                ticketCreatedAt: ticketInfo.createdAt,
            };
            const valid = validatePostCreateAt(dataValidate);
            if (!Utils.isEmptyString(valid.message)) {
                setMessageError(valid.message);
            } else {
                setMessageError('');
            }
        } else {
            setMessageError('');
        }
        
        setListChatInputValues(listChatInputValues.map((item) => {
            return item.id === selectThread.id ? updatedItem: item;
        }))
    };


    /**
     * Handle selected guest user of post msg
     */
    const onChangeSelectedGuestUser = (e) => {
        let userId = e.target.value;
        let seletedUser = _.find(props.userGuestList, ['id', userId]);
        props.setUserDelegateCreateTicketDetail(seletedUser);
    };

    const jumpToBottom = () => {
        scrollToBottom();
        setIsDisplayJump(false);
    }

    const onChangeSettingForm = () => {
        const updatedItem = {
            ...infoChatInputValue,
            isCheckDelegatePostMsg: !isCheckDelegatePostMsg,
            isPostCreatedAtCurrentTime: true
        }
        if (!isCheckDelegatePostMsg) {
            const currentDateTime = new Date()
            updatedItem.postCreatedAtDateTime = moment(currentDateTime).format('YYYY/MM/DD HH:mm')
            setMessageError('');
            setIsSentMessage(true)
            setIsDisableUnsentCheckBox(true)
        }else{
            setIsDisableUnsentCheckBox(false)
        }
        setListChatInputValues(listChatInputValues.map((item) => {
            return item.id === selectThread.id ? updatedItem: item;
        }))
    }

    const onChangeSettingCurrentTime = () => {
        const updatedItem = {
            ...infoChatInputValue,
            isPostCreatedAtCurrentTime: !isPostCreatedAtCurrentTime
        }

        if (isPostCreatedAtCurrentTime) {
            updatedItem.postCreatedAtDateTime = ''
        } else {
            const currentDateTime = new Date()
            updatedItem.postCreatedAtDateTime = moment(currentDateTime).format('YYYY/MM/DD HH:mm')
            setMessageError('')
        }

        setListChatInputValues(listChatInputValues.map((item) => {
            return item.id === selectThread.id ? updatedItem: item;
        }))
    }

    const getUserSendMsgNameInHistory = () => {
        if (!Utils.isEmptyObject(msgEditSelected?.userDetailPostMsg)) {
            let userName = Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                msgEditSelected?.userDetailPostMsg
            );
            if (userName) {
                return userName;
            }
        }
        
        return msgEditSelected?.userDetailPostMsg?.mail;
    };

    const renderEmailTicketFooter = () => {
        if(ticketInfo.ticketType !== Constant.TICKET_TYPE.EMAIL || 
            selectThread.threadType !== Constant.THREAD_TYPE.CUSTOMER) {
            return <></>;
        }

        return (
            <>
                <div className="emailticket-footer-chat">
                    <div className="email-deliver">
                            <Checkbox
                                checked={isDeliver}
                                onClick={() => {
                                    if (isDisableLink) return;
                                    setIsDeliver(!isDeliver)
                                }}
                                disabled={isDisableLink}
                            />
                        <span className={isDisableLink ? 'cursor-default' : ''}>{trI18n('EMAIL_DELIVERY')}</span>
                    </div>

                    <div className="email-detail">
                        <span
                            className={`email-detail-hyperlink ${
                                isDisableLink ? 'email-detail-hyperlink-disable' : ''
                            }`}
                            onClick={e => {
                                if (isDisableLink) return;
                                onHandleClickOpenReplyEmail(e, latestCustomerMess)
                            }}
                            disabled={isDisableLink}
                        >
                            {trI18n('DETAIL_EDIT')}
                        </span>
                    </div>
                </div>
            </>
        );
    }

    // AI Assistant log URL
    useEffect(() => {
        if (!isAIAssistantThread(selectThread) || !chatThreadId) return;
        let isMounted = true;
        const updateLogURL = async () => {
            try {
                const url = await Storage.get(`log-chat-ai/${chatThreadId}.json`, { expires: 7200 });
                if (isMounted && url) {
                    setLogUrl(url);
                }
            } catch (error) {
                Logger.error('Failed to get AI Assistant log URL:', error);
            }
        };
        updateLogURL();
        return () => { isMounted = false; };
    }, [chatThreadId, selectThread]);

    const hasAssistantMessage = () => {
        if (!isAIAssistantThread(selectThread)) return false;
        return chatPostByChatThreadIdList?.some(post => {
            const aiOperatorInfo = getAiOperatorInfoFromPost(post);
            return !!aiOperatorInfo;
        });
    };

    const handleOpenLog = useCallback(async () => {
        try {
            const url = await Storage.get(`log-chat-ai/${chatThreadId}.json`, { expires: 7200 });
            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
            Logger.error('handleOpenLog error:', error);
        }
    }, [chatThreadId]);

    useEffect(() => {
        const handleClickOutside = () => {
            setFocusedMsgId(null);
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    /**
     * Render view
     */
    return (
        <div className="groupChat">
            {/* {isDisplayTicketHeadLine && ( */}
                <TicketHead
                    {...props}
                    API={API}
                    isShowHeadlineButtonGroup={props.isShowHeadlineButtonGroup}
                    isShowAllChatPost={isShowAllChatPost}
                    setIsShowAllChatPost={setIsShowAllChatPost}
                    handleClickViewTicketDetail={handleClickViewTicketDetail}
                    isDisplayTicketHeadLine={isDisplayTicketHeadLine}
                    ticketInfo={ticketInfo}
                    selectThread={selectThread}
                    chatPostAllList={chatPostAllList}
                    chatThreadId={chatThreadId}
                    userDetail={userDetail}
                    setIsLoading={setIsLoading}
                    setTicketInfo={setTicketInfo}
                    panelId={panelId}
                    ticketId={ticketIdSelected}
                    panelType={props.panelType}
                    setIsChatThreadOnAiAssistant={setIsChatThreadOnAiAssistant}
                    {...args}
                ></TicketHead>
            {/* )} */}
            <div className="chatContent" data-cy="chat-content" id='chatContent-container'>
                <div className="scrollBar-main" id={`divChatContentList-${panelId}-${chatThreadId}`} 
                    onScroll={(e) => {
                        onChatScroll();
                        handleScrollListMessage(e, args, null, projectInuseDetail.id, { onChatScroll, isFocusScrolling });
                    }}
                >
                    {chatPostByChatThreadIdList && renderChatList()}
                    {chatPostByChatThreadIdList && renderUnSentChatList()}
                    {isRendering && isAIAssistantEnabledForCurrentThread && !isShowAllChatPost && (
                        <div className="chatBox" data-cy="chat-rendering-indicator">
                            <div className="chatBox-info">
                                <div className="chatBox-thumb">
                                    <img src="/assets/image/icon-user-default.svg" alt="AI" />
                                </div>
                                <div className="chatBox-content">
                                    <div className="chatBox-dateTime">
                                        <span className="name">{tr('AI')}</span>
                                    </div>
                                    <div className="chatBox-text">
                                        <div className="chatBoxContent">
                                            <span className="chatBox-label">
                                                <span className="chatBox-txt">
                                                    <span className="chat-rendering-indicator">
                                                        <span className="rendering-text">{tr('Generating')}</span>
                                                        <span className="rendering-dots">
                                                            <span>.</span><span>.</span><span>.</span>
                                                        </span>
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className={isDisplayJump ? "jumpBottom" : "jumpBottom jumpBottom--dnone"} onClick={jumpToBottom}>
                    <div className="jumpBottom-wrap">
                        <div className="jumpBottom-box">
                            <svg width="16px" height="16px" viewBox="0 0 24 24" className="">
                                <path fill="none" d="M0 0h24v24H0V0z">
                                </path><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
                            </svg>{tr('Jump to Bottom')}
                        </div>
                    </div>
                </div>

                {/* AI Assistant log detail button */}
                {!Utils.isEmptyString(logUrl) && hasAssistantMessage() && (
                    <button
                        className="btn-reset-default ai-log-url-btn"
                        onClick={handleOpenLog}
                    >
                        {trI18n('DETAIL')}
                    </button>
                )}
            </div>
            {isEnableChat && Utils.isEmptyString(ticketInfo?.deletedAt) && !isAIAssistantSettingOff ? (
                <div className="formChat-wrap">
                    <div className="formChat">
                        
                        {/*  */}
                        <div className='groupForm-chat groupForm-chat--thread'>
                            <ChatInput 
                                API={API}
                                panelId={panelId}
                                corporationId={corporationId}
                                ticketInfo={ticketInfo}
                                chatThreadId={chatThreadId}
                                selectThread={selectThread}
                                userDetail={userDetail}
                                userDelegateCreateTicketDetail={props.userDelegateCreateTicketDetail}
                                isCheckDelegatePostMsg={isCheckDelegatePostMsg}
                                isPostCreatedAtCurrentTime={isPostCreatedAtCurrentTime}
                                postCreatedAtDateTime={postCreatedAtDateTime}
                                setIsCreateNewMsg={setIsCreateNewMsg}
                                setChatPostAllList={props.setChatPostAllList}
                                messageError={messageError}
                                setMessageError={setMessageError}
                                setChatPostInsertFail={props.setChatPostInsertFail}
                                setChatPostUpdate={setChatPostUpdate}
                                selectedProjectId={selectedProjectId}
                                userListCanMention={userListCanMention}
                                userChatList={props.userChatList}
                                setUserChatList={props.setUserChatList}
                                setIsModalUploadFileError={setIsModalUploadFileError}
                                setFileUploading={setFileUploading}
                                fileUploadedList={props.fileUploadedList}
                                setFileUploadedList={props.setFileUploadedList}
                                threadChatList={threadChatList}
                                corporationDetail={corporationDetail}
                                projectInuseDetail={projectInuseDetail}
                                chatPostAllList={chatPostAllList}
                                notShowMention={isEmailTicketCustomerChatthread(ticketInfo, selectThread)}
                                isDeliver={isDeliver}
                                setIsLoading={setIsLoading}
                                reloadTicketDetail={reloadTicketDetail}
                                setLastedSendMsgIdState={setLastedSendMsgIdState}
                                setIsDeliver={setIsDeliver}
                                isDisableActionEditTicket={isDisableActionEditTicket}
                                isEnableChat={isEnableChat}
                                isDisableUserListDelegateMsg={isDisableUserListDelegateMsg}
                                onChangeSettingForm={onChangeSettingForm}
                                onChangeSettingCurrentTime={onChangeSettingCurrentTime}
                                onChangeSelectedGuestUser={onChangeSelectedGuestUser}
                                handlePostCreatedAtDateTimeOnChange={handlePostCreatedAtDateTimeOnChange}
                                isSentMessage={isSentMessage}
                                setIsSentMessage={setIsSentMessage}
                                customerReferenceThread={customerReferenceThread}
                                isDisableLink={isDisableLink}
                                isDisableUnsentCheckBox={isDisableUnsentCheckBox}
                                setIsDisableUnsentCheckBox={setIsDisableUnsentCheckBox}
                                uploadFiles={uploadFiles}
                                setUploadFiles={setUploadFiles}
                                setUploadedFiles={setUploadedFiles}
                                setIsRendering={setIsRendering}
                                setIdMessageRendering ={setIdMessageRendering}
                                {...props}
                                isShowAllChatPost={isShowAllChatPost}
                                isChatThreadOnAiAssistant = {isChatThreadOnAiAssistant}
                            />
                        </div>
                        {renderEmailTicketFooter()}
                    </div>
                </div>
            ) : <></>}
            <ErrorModal
                open={isModalUploadFileError}
                message={trI18n('USER07MSG004')}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
            />
            {/* show history dialog */}
            <Dialog
                open={isOpenHistoryDialog}
                onClose={e => { setIsOpenHistoryDialog(false); }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
            >
                <DialogTitle className="titleHeader">
                    <h2 className="title">{tr('編集履歴')}</h2>
                    {msgEditSelected?.creatorId &&
                        <h5 className="userNameHistoryTitle">
                            {getUserSendMsgNameInHistory()}
                        </h5>
                    }
                    <IconButton className="close" onClick={e => { setIsOpenHistoryDialog(false); }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {
                        isLoadingHistoryList ? <LoadingIndicator isLoading={isLoadingHistoryList} />
                            :
                            <div className="contentChart-dialog text-align-left-important">
                                <ul>
                                    {historyList}
                                </ul>
                            </div>
                    }
                </DialogContent>
            </Dialog>
            {/* dialog confirm delete msg  */}
            <DeleteMessageDialog 
                argsAll={args} 
            />

            <ReactionErrorDialog
                isOpen={isOpenReactionErrorDialog}
                setIsOpen={setIsOpenReactionErrorDialog}
                reactionErrorMsg={reactionErrorMsg}
                setReactionErrorMsg={setReactionErrorMsg}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={trI18n('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={tr('はい')}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={trI18n('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={<div><span>{trI18n('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{trI18n('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                textSubmit={trI18n('COMBTN004')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
            <ConfirmDialog
                isOpen={isOpenModalReloadPage}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
        </div>
    );
}


export default Chat
